import React from 'react';
import type { TabsProps } from 'antd';
import { Tabs, Typography } from 'antd';
import styled from 'styled-components';

import { applyTemplateVariables } from './applyTemplateVariables';
import { ConsentTemplate, consentTypeMap } from './Consents.types';

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav-list {
    width: 100%;
  }

  .ant-tabs-tab {
    flex: 1 0 0;
    display: flex;
    justify-content: center;
  }
`;

export const ConsentTemplatePreview: React.FC<{
  consentTemplate?: ConsentTemplate;
  showTitle?: boolean;
  clientName?: string;
  projectName?: string;
}> = ({ consentTemplate, showTitle = true, clientName, projectName }) => {
  if (!consentTemplate) {
    return null;
  }

  const renderContent = (rawContent?: string | null) =>
    applyTemplateVariables({
      rawContent,
      variables: {
        CLIENT_NAME: clientName ?? null,
        PROJECT_NAME: projectName ?? null
        // TODO: Add `POSITION` variable for `PROJECT_PARTICIPATION` consent type
      },
    });

  const items: TabsProps['items'] = [
    {
      key: 'pl',
      label: 'Polish',
      children: (
        <Typography.Text style={{ whiteSpace: 'pre-line' }}>{renderContent(consentTemplate.content)}</Typography.Text>
      ),
    },
    {
      key: 'en',
      label: 'English',
      disabled: !consentTemplate.englishContent,
      children: (
        <Typography.Text style={{ whiteSpace: 'pre-line' }}>
          {renderContent(consentTemplate.englishContent)}
        </Typography.Text>
      ),
    },
  ];

  return (
    <>
      {showTitle && <Typography.Title level={5}>{consentTypeMap[consentTemplate.type]}</Typography.Title>}
      <StyledTabs items={items} />
    </>
  );
};
